var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoofA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 120,
    viewBox: "0 0 160 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 109H31V8H129V109H122.425",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.402 63.2969H94.5586V104.342H119.402V63.2969Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1438 104.344H120.809V108.086H93.1438V104.344Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0566 108.078H122.887V111.827H91.0566V108.078Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20H39V112H86V20Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4277 75.125H78.4141V96.0747H45.4277V75.125Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4277 29H78.4141V49.9497H45.4277V29Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.434 87.3214V83.5906C112.434 83.3026 112.891 83.0703 113.453 83.0703C114.017 83.0703 114.474 83.3026 114.474 83.5906V87.3214C114.474 87.6094 114.017 87.8427 113.453 87.8427C112.891 87.8427 112.434 87.6094 112.434 87.3214Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofA);
export default __webpack_public_path__ + "static/media/roof-a.0bc54d78c74dcde049dc2fa32d03dfc3.svg";
export { ForwardRef as ReactComponent };